import { ISfWallet } from '@sparling/financial-common'
import { IColumns } from '../../../../components/Table'

export type WalletColumnKeys = 'id' | 'currency' | 'address' | 'addressSuffix' | 'addressProtocol' | 'actions'

export const columns: IColumns<WalletColumnKeys, ISfWallet>[] = [
  {
    id: 'id',
    label: 'ID',
  },
  {
    id: 'currency',
    label: 'Currency',
  },
  {
    id: 'address',
    label: 'Address',
  },
  // {
  //   id: 'addressSuffix',
  //   label: 'Address Suffix',
  // },
  // {
  //   id: 'addressProtocol',
  //   label: 'Address Protocol',
  // },
  // {
  //   id: 'actions',
  //   label: 'Action',
  // },
]
